import React, { useEffect, useRef, useState } from 'react'
import dotsIcon from "../../assets/img/vertical-dots.svg"
import SelectedThemeInput from '../custom-theme/commons/select-theme-input'
import SelectedCustomTheme from '../custom-theme/commons/select-custom-theme'
import { apiUrl } from '../../utils/url'
import { hideLoader, showLoader } from '../loader'
import { toast } from 'react-toastify'
import { createFormdataValues } from '../../utils/createFormdataValues'
import { useDispatch, useSelector } from 'react-redux'
import ErrorMessage from '../errors/errorMessage'
import SettingsHeader from './settings-header'
import useDebounce from '../../services/useDebounce'
import CropperModal from '../cropper-modal'

const EditBranding = ({ data, setData , activePage, setActivePage }) => {
    const { slug } = useSelector(state => state?.slugReducer);
    const [value, setValue] = useState(data);
    const dispatch = useDispatch();
    const brandings = useSelector(state => state?.brandingReducer);
    const [error, setError] = useState();
    const [timer, setTimer] = useState(null);
    const [count, setCount] = useState(0);
    const [croppie, setCroppie] = useState(null);
    const [croppie_image, setcroppie_image] = useState({ url: "", id: null });
    const [showCroppieModal, setshowCroppieModal] = useState(null);
    const cropperRef = useRef(null);
    const handleHideModal = () => {
        setshowCroppieModal(false);
        setCroppie(null);
        setcroppie_image({ url: "", id: null });
        // history.push(basePath + "/products");
    };
    const croppieClose = () => {
        showLoader();
        setshowCroppieModal(false);
        setCroppie(null);
        setTimeout(() => {
          hideLoader();
        }, 400);
      };
      const croppedImage = () => {
        if (croppie !== null) {
          const cropper = cropperRef.current.cropper;
          cropper.getCroppedCanvas().toBlob((blob) => {
              // Do something with the Blob, like setting it to state
              // Optionally create a URL for preview purposes
              const croppedBlobUrl = URL.createObjectURL(blob);
              setValue({ ...value, logo_url: croppedBlobUrl, logo: blob });
              
              // Close the croppie/modal
              croppieClose();
          }, 'image/png', 1);
          return;
        }
      };
    const fonts = [
        { value: "'GT Walsheim Pro', sans-serif", name: 'GT Walsheim Pro' },
        { value: 'Arial, Helvetica, sans-serif', name: 'Arial' },
        { value: 'Arial Black, Helvetica, sans-serif', name: 'Arial Black' },
        { value: 'Helvetica, sans-serif', name: 'Helvetica' },
        { value: 'Times New Roman, serif', name: 'Times New Roman' },
        { value: 'Courier New, Courier, monospace', name: 'Courier New' },
        { value: 'Verdana, Geneva, sans-serif', name: 'Verdana' },
        { value: "'Roboto', sans-serif", name: 'Roboto' },
      ];
    const themeChange = () => {
        $('.color-picker-modal').removeClass("d-none");
        $('.color-picker-main').removeClass("d-none");
        $('.color-picker-modal').addClass("d-flex");
        $('.color-picker-main').addClass("d-flex");
    };
    const handleChange = (e) => {
        const { name } = e.target;
        if (name === 'logo' && e.target.files.length > 0) {
            const fileList = e.target.files[0];
            var reader = new FileReader();
    
            reader.onload = function (event) {
                const logoValue = event.target.result;
                setValue({ ...value, [name]: logoValue });
            };
            reader.readAsDataURL(fileList);
        } else {
            setValue({ ...value, [name]: e.target.value });
        }
    };
    const colorChange = (color) => {
        setValue({ ...value, brand_color: color })
    };
    function autoResize(textarea) {
        if (textarea.value.length > 80) {
            textarea.style.height = "auto";
            textarea.style.height = textarea.scrollHeight + "px";
        } else {

            textarea.style.height = "30px";
        }
    }
    const debouncedValues = useDebounce(value, 1500);
    // useEffect(() => {
    //     if(value?.brand_name && value?.brand_color){
    //         changeDelay();
    //     }
    // }, [value])
    // useEffect(() => {
    //     if (debouncedValues && value?.brand_name) {
    //         handleSubmit();
    //     }
    // }, [debouncedValues]);
    function changeDelay() {
        if (timer) {
            clearTimeout(timer);
            setTimer(null);
        }
        setTimer(
            setTimeout(() => {
                handleSubmit();
            }, 3000)
        );
    };
    
    const handleSubmit = (e) => {
        const { brand_color, type, id, project, ...rest } = value;
        const hasOtherValues = Object.keys(rest).length > 0;
        if (!hasOtherValues) {
            return;
        }
        setError([]);
        e?.preventDefault();
        var api = apiUrl + "/branding/" + (count == 0 && data?.type && data?.type == 'create' ? 'create' : 'update');
        showLoader()
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
        const formdata = createFormdataValues(value);
        formdata.append("project", slug);
        // if(count > 0 && data?.type && data?.type == 'create'){
        //     formdata.append("id", brandings[brandings?.length - 1]?.id);
        // }
        const setOptions = {
            method: "POST",
            body: formdata,
            headers: myHeaders,
        }
        fetch(api, setOptions)
            .then(async (res) => {
                const response = await res?.json();
                if (response?.status_code == 200) {
                    if (count == 0 && data?.type && data?.type == 'create') {
                        setValue(response?.data?.branding);
                        const updatedBrandings = [...brandings?.data];
                        updatedBrandings.push(response?.data?.branding);
                        dispatch({ type: "SET_BRANDING", payload: {...brandings, data:updatedBrandings} });
                        setCount(1);
                    }else{
                        const index = brandings.findIndex(item => item?.id === value?.id);
                        if (index !== -1) {
                            const updatedBrandings = [...brandings?.data];
                            updatedBrandings[index] = value;
                            dispatch({ type: "SET_BRANDING", payload: {...brandings, data:updatedBrandings} });
                            toast.success(response?.status_message);
                        }
                    }
                    hideLoader();
                    // toast.success(response?.status_message)
                } else {
                    toast.error(response?.status_message)
                    if(response?.data?.includes('DNS')){
                        setError([response?.data]);
                    }
                    setError(Object.values(response?.errors));
                    if (Object.keys(response?.errors).length > 0)
                        $(".modal-body").scrollTop(0);
                    hideLoader();
                }
                hideLoader();
            }).catch(() => {
                hideLoader();
            });
    }
    const handleSelectValue = (val) => {
        setValue({...value,"font":JSON.stringify(val)})
    };
    const handleopenmodal = (e) => {
        setcroppie_image({ url: "", id: null, name: null, type: null });
        generate_image_preview(e.target);
        hideLoader();
    };
    function generate_image_preview(input) {
        showLoader();
        if (input.files && input.files[0]) {
          let reader = new FileReader();
          if (input.files[0].size >= 5242880) {
            $("#image_file_input").val("");
            let notification_container = $(".notification-container");
            toast.error("File Size Should not exceed 5MBs");
            // showModal();
            return;
          }
          let val = input.files[0].name;
          let valid_extensions = ["png", "jpg", "jpeg"];
          let extension =
            val.substring(val.lastIndexOf(".") + 1, val.length) || val;
          if (!valid_extensions.includes(extension)) {
            $("#image_file_input").val("");
            let notification_container = $(".notification-container");
            toast.error("Invalid Image File. Should be png, jpg or jpeg");
            // showModal();
            return;
          }
          const files = event.target.files;
          reader.onload = () => {
            setshowCroppieModal(true);
            setCroppie(reader.result);
          };
          reader.readAsDataURL(files[0]);
        }
      }
    return (
        <div className='up-cont-u'>
            <section className='edit-branding-section'>
            <SettingsHeader page={"Branding"} subpage={value?.brand_name} activePage={'branding'} description={'Create brands to use across your GenPage campaigns'} setActivePage={setActivePage}/>
                <div className='edit-branding-cont'>
                    <ErrorMessage error={error} />
                    <form action="">
                        <div className='brandig-profile-pic-main'>
                            <div className="brandig-profile-pic">
                                {
                                    value?.logo &&
                                    <img src={value?.logo_url ?? value?.logo} alt="" />
                                }
                            </div>
                            <div className='d-flex flex-column'>
                                <span className='productlabels'>
                                Company Logo
                                </span>
                                <button type="button" className="mt-10px cursor-pointer newGraybtn position-relative bg-white">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6 0C6.41421 0 6.75 0.335786 6.75 0.75V5.25H11.25C11.6642 5.25 12 5.58579 12 6C12 6.41421 11.6642 6.75 11.25 6.75H6.75V11.25C6.75 11.6642 6.41421 12 6 12C5.58579 12 5.25 11.6642 5.25 11.25V6.75H0.75C0.335786 6.75 0 6.41421 0 6C0 5.58579 0.335786 5.25 0.75 5.25H5.25V0.75C5.25 0.335786 5.58579 0 6 0Z" fill="#333333" />
                                    </svg>
                                    <span>
                                    Upload Logo
                                    </span>
                                    <input
                                        onChange={(e)=>handleopenmodal(e)}
                                        // onChange={handleChange}
                                        type="file"
                                        className="dropzone dropzone4 inset-0"
                                        name="logo"
                                        accept=".png,.jpg,.jpeg"
                                        id="image_file_input"
                                    // onChange={(e)=>onfilechange(e,i)}
                                    />
                                </button>
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="productlabels">
                                Company Name
                            </label>
                            <input
                                onChange={handleChange}
                                value={value?.brand_name}
                                type="text"
                                className="zaapGlobal-input"
                                name="brand_name"
                                placeholder="Company Name"
                            />
                        </div>
                        <div className="form-group mt-20px">
                            <label className="productlabels">
                            Website URL
                            </label>
                            <input
                                onChange={handleChange}
                                value={value?.website_url}
                                type="url"
                                className="zaapGlobal-input"
                                name="website_url"
                                placeholder="domain.com"
                            />
                        </div>
                        <div className="form-group mt-20px">
                            <div className="col-6 pl-0 d-flex align-items-center" id="header-theme">
                                <span className="zaap-normal-text">Brand Color</span>
                            </div>
                            <SelectedThemeInput data_type={"brand_color"} themeType="brand_color" color={value?.brand_color} themeChange={themeChange} />
                            <SelectedCustomTheme nthChild="" themeType="brand_color" color={value?.brand_color} from={'campaigns'} colorChange={colorChange} />
                        </div>
                        <div className="form-group mt-20px">
                            <label className="productlabels">
                                Company Description
                            </label>
                            <textarea
                                type="text"
                                value={value?.company_description && value?.company_description != 'null' ? value?.company_description : ''}
                                className="zaapGlobal-input hidden-scroll"
                                name="company_description"
                                placeholder={"Tell us about your company. This is used to build your campaign."}
                                onInput={(e) => autoResize(e.target)}
                                style={{ minHeight: "50px" }}
                                onChange={handleChange}
                            >
                            </textarea>
                        </div>
                        <div>
                        </div>
                        <div className="form-group mt-20px">
                            <label className="productlabels">
                                Default Font
                            </label>
                            <div class="table-action-dropdown d-flex justify-content-between align-items-center gap-2 cursor-pointer zaapGlobal-input dropdown-toggle noselect dropdown-subscribers" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false" >
                                <span className="d-flex align-items-center gap-2">
                                    {value?.font ? JSON.parse(value?.font)?.name : fonts[0]?.name}
                                </span>
                            </div>
                            <ul class="dropdown-menu brand-dropdown-menu" aria-labelledby="table-action-dropdown">
                                {fonts?.length > 0 && (
                                    fonts.map((val, idx) => (
                                        <li key={idx} onClick={() => handleSelectValue(val)}>
                                            <a class={`dropdown-item cursor-pointer border-radius-9`} >
                                                <span>{val?.name} </span>
                                            </a>
                                        </li>
                                    ))
                                )}
                            </ul>
                        </div>
                        <div className='account-form mt-20px'>
                            <div className="domain-steps-label" style={{marginTop:"20px",marginBottom:"11px"}}>
                                Step 1: Add an A record to your DNS
                            </div>
                            <div class="form-group  w-100 domain-first-step-fields" >
                                <div className="first-step-name-field">
                                    <label><small>Name</small></label>
                                    <input type="text" class={`form-control text-center`} name="name" value="@" readonly/>
                                </div>
                                <div className="first-step-value-field">
                                    <label><small>Value</small></label>
                                    <div class="form-control p-0 position-relative">
                                        <input type="text" class={`form-control w-100`} name="value" value="34.226.84.124" readonly/>
                                            <span className="first-step-value-icon" onClick={() => {navigator.clipboard.writeText(`${"34.226.84.124"}`).then((r) => toast.success("Successfully Copied"))}}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M2.32121 0.255372C2.32895 0.255372 2.33672 0.255372 2.34451 0.255372L6.01933 0.255372C6.25328 0.255363 6.45936 0.255355 6.63077 0.267051C6.81249 0.279449 7.00038 0.307053 7.18791 0.384733C7.60432 0.557214 7.93515 0.888047 8.10763 1.30445C8.18531 1.49199 8.21292 1.67988 8.22532 1.8616C8.23701 2.03301 8.237 2.23909 8.23699 2.47303V2.49237C8.23699 2.83715 7.9575 3.11664 7.61272 3.11664C7.26794 3.11664 6.98844 2.83715 6.98844 2.49237C6.98844 2.23335 6.9881 2.07035 6.97966 1.94659C6.9716 1.82844 6.95828 1.7923 6.95412 1.78225C6.90836 1.67178 6.82059 1.58401 6.71011 1.53825C6.70007 1.53409 6.66393 1.52077 6.54578 1.51271C6.42202 1.50427 6.25902 1.50393 6 1.50393H2.34451C2.03314 1.50393 1.83716 1.50441 1.68919 1.5165C1.54852 1.528 1.50705 1.54679 1.49473 1.55307C1.4099 1.59629 1.34092 1.66527 1.2977 1.7501C1.29142 1.76242 1.27262 1.80389 1.26113 1.94456C1.24904 2.09253 1.24856 2.28851 1.24856 2.59988V6.25537C1.24856 6.51439 1.24889 6.67739 1.25734 6.80115C1.2654 6.9193 1.27872 6.95544 1.28288 6.96548C1.32864 7.07596 1.41641 7.16373 1.52688 7.20949C1.53693 7.21365 1.57307 7.22697 1.69122 7.23503C1.81498 7.24347 1.97798 7.24381 2.237 7.24381C2.58177 7.24381 2.86127 7.52331 2.86127 7.86809C2.86127 8.21287 2.58177 8.49237 2.237 8.49237H2.21766C1.98371 8.49237 1.77764 8.49238 1.60623 8.48069C1.42451 8.46829 1.23662 8.44069 1.04908 8.363C0.632676 8.19052 0.301843 7.85969 0.129362 7.44328C0.0516823 7.25575 0.0240782 7.06786 0.0116794 6.88614C-1.56436e-05 6.71473 -7.90398e-06 6.50865 8.27931e-07 6.27471L1.35714e-06 2.59988C1.35714e-06 2.59209 1.02638e-06 2.58432 6.9563e-07 2.57658C-1.20053e-05 2.29545 -2.30525e-05 2.04785 0.0167226 1.84289C0.0345248 1.625 0.0743206 1.40094 0.185227 1.18327C0.348157 0.863506 0.608135 0.603528 0.927902 0.440598C1.14557 0.329692 1.36963 0.289896 1.58752 0.272094C1.79248 0.255348 2.04008 0.255359 2.32121 0.255372ZM6.08422 4.01838H9.67879C9.95993 4.01836 10.2075 4.01835 10.4125 4.0351C10.6304 4.0529 10.8544 4.0927 11.0721 4.2036C11.3919 4.36653 11.6518 4.62651 11.8148 4.94628C11.9257 5.16394 11.9655 5.38801 11.9833 5.6059C12 5.81085 12 6.05844 12 6.33957V9.93417C12 10.2153 12 10.4629 11.9833 10.6679C11.9655 10.8857 11.9257 11.1098 11.8148 11.3275C11.6518 11.6472 11.3919 11.9072 11.0721 12.0701C10.8544 12.1811 10.6304 12.2208 10.4125 12.2386C10.2075 12.2554 9.95993 12.2554 9.6788 12.2554H6.0842C5.80307 12.2554 5.55548 12.2554 5.35053 12.2386C5.13264 12.2208 4.90857 12.1811 4.69091 12.0701C4.37114 11.9072 4.11116 11.6472 3.94823 11.3275C3.83733 11.1098 3.79753 10.8857 3.77973 10.6679C3.76298 10.4629 3.76299 10.2153 3.76301 9.93416V6.33959C3.76299 6.05845 3.76298 5.81085 3.77973 5.6059C3.79753 5.38801 3.83733 5.16394 3.94823 4.94628C4.11116 4.62651 4.37114 4.36653 4.69091 4.2036C4.90857 4.0927 5.13264 4.0529 5.35053 4.0351C5.55548 4.01835 5.80308 4.01836 6.08422 4.01838ZM5.4522 5.27951C5.31152 5.291 5.27006 5.3098 5.25774 5.31607C5.1729 5.3593 5.10393 5.42827 5.0607 5.51311C5.05443 5.52543 5.03563 5.56689 5.02414 5.70757C5.01205 5.85553 5.01156 6.05152 5.01156 6.36289V9.91086C5.01156 10.2222 5.01205 10.4182 5.02414 10.5662C5.03563 10.7069 5.05443 10.7483 5.0607 10.7606C5.10393 10.8455 5.1729 10.9144 5.25774 10.9577C5.27006 10.964 5.31152 10.9827 5.4522 10.9942C5.60016 11.0063 5.79614 11.0068 6.10751 11.0068H9.65549C9.96686 11.0068 10.1628 11.0063 10.3108 10.9942C10.4515 10.9827 10.4929 10.964 10.5053 10.9577C10.5901 10.9144 10.6591 10.8455 10.7023 10.7606C10.7086 10.7483 10.7274 10.7069 10.7389 10.5662C10.751 10.4182 10.7514 10.2222 10.7514 9.91086V6.36289C10.7514 6.05152 10.751 5.85553 10.7389 5.70757C10.7274 5.56689 10.7086 5.52543 10.7023 5.51311C10.6591 5.42827 10.5901 5.3593 10.5053 5.31607C10.4929 5.3098 10.4515 5.291 10.3108 5.27951C10.1628 5.26742 9.96686 5.26693 9.65549 5.26693H6.10751C5.79614 5.26693 5.60016 5.26742 5.4522 5.27951Z" fill="#6F6E7A"/>
                                            </svg>
                                            </span>
                                    </div>
                                </div>
                                <div className="first-step-ttl-field">
                                    <label><small>TTL</small></label>
                                    <input type="text" class={`form-control text-center`} name="ttl" value="Auto" readonly/>
                                </div>
                            </div>
                        </div>
                        <div className="form-group mt-20px">
                            <label className="productlabels">
                                Custom Domain
                            </label>
                            <input
                                onChange={handleChange}
                                value={value?.custom_domain}
                                type="url"
                                className="zaapGlobal-input"
                                name="custom_domain"
                                placeholder="https://mydomain.com"
                            />
                        </div>
                        <div className="form-group mt-20px text-right">
                            <button type='button' className='fs-12 shadow-none project-blue-btn' onClick={handleSubmit}>
                                Save Changes
                            </button>
                        </div>
                    </form>
                </div>
            </section>
            <CropperModal croppie={croppie} cropperRef={cropperRef} show={showCroppieModal} handleHide={handleHideModal} croppieClose={croppieClose} croppedImage={croppedImage} modalWidth={500} productCroppie={"productCroppie"} />
        </div>
    )
}

export default EditBranding